export default __webpack_public_path__ + "maps-examples-dds-circle-layer-960-c6c6f14e39b1b2c85b7e92c51b5c6ada.webp";